export function applyHeightBkgImgHeroOverlay() {
  const findHeight = document.querySelectorAll(
    ".hero-bkg-img-overlay > .row"
  )[0];
  const heightResult = findHeight.offsetHeight;
  const applyHeight = document.querySelectorAll(
    ".hero-bkg-img-overlay > .hero-bg-img"
  )[0];

  if (window.outerWidth >= 800) {
    applyHeight.style.width = `${(heightResult * 4) / 3}px`;
  }
}
